import { FC, useState } from 'react';

import { useNotices } from '@/features/notices/useNotices';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';
import { files } from '@/shared/utils/files';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { numbers } from '@/shared/utils/numbers';

import { useModalsStore } from '../../modals.store';
import { PhotoPreviewModalProps } from '../../types';

import { Carousel } from './Carousel';

import { Header, IconWrap, ImageWrap, StyledModal } from './styles';

export const PhotoPreviewModal: FC<PhotoPreviewModalProps> = ({
  onRemove,
  decryptedPhotoIdsRef,
  getFile,
  images,
  initialIndex,
  readOnly,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'photoPreview' });
  const modals = useModalsStore();
  const notices = useNotices();

  const carouselOptions = { decryptedPhotoIdsRef, getFile, images, initialIndex };
  const [fileData, setFileData] = useState(images[initialIndex]);

  const handleRemove = () => {
    modals.closeModal();
    onRemove(fileData.id);
  };

  const handleDownload = () => {
    if (!(fileData.file instanceof File) || fileData.file === undefined) return;
    files.downloadFile(fileData.file, fileData.file.name);
  };

  const switchFileData = (index: number) => {
    setFileData(images[index]);
  };

  return (
    <StyledModal open={true} centered footer={null} width={1340} onCancel={modals.closeModal}>
      <Header>
        <div>
          <Title style={{ color: 'inherit' }} size={16} bold>
            {fileData.name}
          </Title>
          {fileData?.size && (
            <div className="sub-title">({numbers.formatUnits(fileData.size, 'kilobyte')})</div>
          )}
        </div>
        <div className="second-side">
          {!readOnly && (
            <>
              <IconWrap onClick={() => notices.antd.confirm(t('confirmText'), handleRemove)}>
                <Icon name="trash" size="s20" />
                <div className="icon-text">{t('actions.remove')}</div>
              </IconWrap>
              <IconWrap onClick={handleDownload}>
                <Icon name="download-simple" size="s20" />
                <div className="icon-text">{t('actions.download')}</div>
              </IconWrap>
            </>
          )}
        </div>
      </Header>
      <ImageWrap>
        <Carousel {...carouselOptions} onChangeIndex={switchFileData} />
      </ImageWrap>
    </StyledModal>
  );
};
